import React, { useEffect, useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import BadResponseDialog from "./BadResponseDialog";

const MessageFeedback = ({ messageId, onFeedback, is_good_answered }) => {
  const [feedback, setFeedback] = useState(is_good_answered === true ? "good" : is_good_answered === false ? "bad" : null);
  const [showBadDialog, setShowBadDialog] = useState(false);
  useEffect(() => {
    if(is_good_answered !== null && is_good_answered !== undefined) setFeedback(is_good_answered === true ? "good" : "bad");
    else setFeedback(null);
  }, [is_good_answered]);
  const handleGoodResponse = (e) => {
    e.stopPropagation();
    setFeedback("good");
    onFeedback && onFeedback(messageId, "good");
  };

  const handleBadResponse = () => {
    setShowBadDialog(true);
  };

  const handleBadReasonSubmit = (reasons, feedbackText) => {
    setFeedback("bad");
    setShowBadDialog(false);
    onFeedback?.(messageId, "bad",  reasons, feedbackText);
  };

  return (
    <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
      <Tooltip title="Bonne réponse">
        <IconButton
          size="small"
          onClick={handleGoodResponse}
          sx={{
            color: feedback === "good" ? "#4CAF50" : "#757575",
            "&:hover": {
              color: "#4CAF50",
              backgroundColor: "rgba(76, 175, 80, 0.04)",
            },
          }}
          //disabled={is_good_answered !== null && is_good_answered !== undefined}
        >
          <ThumbUpIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      
      <Tooltip title="Mauvaise réponse">
        <IconButton
          size="small"
          onClick={handleBadResponse}
          sx={{
            color: feedback === "bad" ? "#F44336" : "#757575",
            "&:hover": {
              color: "#F44336",
              backgroundColor: "rgba(244, 67, 54, 0.04)",
            },
          }}
          //disabled={is_good_answered !== null && is_good_answered !== undefined}
        >
          <ThumbDownIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <BadResponseDialog
        open={showBadDialog}
        onClose={() => setShowBadDialog(false)}
        onSubmit={handleBadReasonSubmit}
      />
    </Box>
  );
};

export default MessageFeedback;